import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import cn from 'classnames';
import "./NavigationSmall.css";
var styles = { "navigationSmall": "e9e7d9" };
const NavigationSmall = forwardRef((_a, ref) => {
    var { Tag = 'a', children, className, hasDataTrackingPii, testId } = _a, props = __rest(_a, ["Tag", "children", "className", "hasDataTrackingPii", "testId"]);
    return (React.createElement(Tag, Object.assign({ className: cn(styles.navigationSmall, className), "data-tracking-pii": hasDataTrackingPii, "data-testid": testId, 
        // INFO: For dynamic tag types
        // @ts-ignore
        ref: ref }, props), children));
});
export default NavigationSmall;
//# sourceMappingURL=NavigationSmall.js.map